import React, { useEffect, useRef, useState } from "react";
import ResponsiveImg from "./ResponsiveImg";

export const HERO_BG = "bg-[#B9D3E8]";

// Hero image + dark overlay that fade in only once the photo has loaded (light-blue placeholder meanwhile)
export default function HeroMedia({ src, alt, overlay }) {
  const [loaded, setLoaded] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    setLoaded(Boolean(ref.current?.complete && ref.current?.naturalWidth));
  }, [src]);

  const fade = `transition-opacity duration-700 ${loaded ? "opacity-100" : "opacity-0"}`;
  return (
    <>
      {src && (
        <ResponsiveImg
          ref={ref}
          src={src}
          priority
          alt={alt}
          onLoad={() => setLoaded(true)}
          className={`absolute inset-0 w-full h-full object-cover ${fade}`}
        />
      )}
      <div data-testid="hero-overlay" className={`absolute inset-0 ${overlay} ${fade}`} />
    </>
  );
}
